import React from 'react'

/**
 * 高度折叠动画容器（Nav Menu UI handoff §06）。
 * 不用 grid-template-rows 0fr→1fr（部分 webview 会卡在 0）；
 * 方案：测量内容高度 → 过渡 → 展开完成后设回 auto（内容变化自适应，
 * 搜索过滤时必需）；收起时先定格 px 再降到 0。
 */
export const Collapse = ({ open, children }: { open: boolean; children: React.ReactNode }) => {
  const inner = React.useRef<HTMLDivElement>(null)
  const [h, setH] = React.useState<number | 'auto'>(open ? 'auto' : 0)
  const first = React.useRef(true)

  React.useLayoutEffect(() => {
    if (first.current) {
      first.current = false
      return
    }
    const el = inner.current
    if (!el) return
    if (open) {
      setH(el.scrollHeight)
      const t = setTimeout(() => setH('auto'), 240)
      return () => clearTimeout(t)
    }
    // 收起：先把 auto 定格成当前 px，下一帧再降到 0 才有过渡
    setH(el.scrollHeight)
    const raf = requestAnimationFrame(() => requestAnimationFrame(() => setH(0)))
    return () => cancelAnimationFrame(raf)
  }, [open])

  return (
    <div
      className="nv-clp"
      style={{ height: h, overflow: h === 'auto' ? 'visible' : 'hidden' }}
      // 收起后高度 0 + overflow hidden 只是「看不见」，里面的链接仍在 Tab 序列里：
      // 键盘用户 Tab 会一路走进看不见的菜单项（焦点落在吸附标题后面）。inert 把整组
      // 移出焦点序列与无障碍树，展开时再放回来。
      inert={!open}
    >
      <div ref={inner}>{children}</div>
    </div>
  )
}
